import { Clinic, Consultation, Patient, PetInfo, PetOwner, RenalDetectRecommendation } from '@app/core/models';
import { NextVisitData } from '@app/core/models/visit-next';
import { SaveConsultationPopinFormValuesOutput } from '@app/shared/components/share-reco-popin/share-reco-popin';
import { createAction, props } from '@ngrx/store';

export const setCurrentConsultationVisitDate = createAction('[Consultation] Set Current Visit Date', props<{ value: Date }>());
export const setConsultationPatient = createAction('[Consultation] Set Patient', props<{ value: Patient }>());
export const setConsultationRenalDetectRecommendation = createAction(
  '[Consultation] Set Renal Detect Recommendation',
  props<{ value: RenalDetectRecommendation }>(),
);
export const setConsultationLastConsultation = createAction('[Consultation] Set Last Consultation', props<{ value: Consultation }>());

export const setConsultationSetSkipProductBook = createAction(
  '[Consultation] Set the fact to skip product book during a flow',
  props<{ value: boolean }>(),
);
export const resetConsultationData = createAction('[Consultation] Reset Data');
/***
 * Create consultation action
 */
export const createCurrentConsultation = createAction(
  '[Consultation] Create Current Consultation',
  props<{
    consultationData: Partial<Consultation>;
    petInfo: PetInfo;
    createPatientPopinTitle?: string;
    owner?: PetOwner;
    isRenewal?: boolean;
  }>(),
);
export const createCurrentConsultationFromShareRecoPopin = createAction(
  '[Consultation] Create Current Consultation from Share Reco Popin',
  props<{
    formValues: SaveConsultationPopinFormValuesOutput;
    consultationData: Partial<Consultation>;
    petInfo: PetInfo;
    isRenewal?: boolean;
  }>(),
);
export const createCurrentConsultationSuccess = createAction(
  '[Consultation] Create Current Consultation Success',
  props<{ consultation: Consultation; newPet: boolean }>(),
);
export const createCurrentConsultationFail = createAction('[Consultation] Create Current Consultation Fail', props<{ error: string }>());
export const setCreatingCurrentConsultation = createAction('[Consultation] Creating Current Consultation', props<{ value: boolean }>());

/***
 * Pet owner actions
 */
export const setConsultationPetOwner = createAction('[Consultation] Set Pet Owner', props<{ value: PetOwner }>());
export const petOwnerFail = createAction('[Consultation] Pet Owner Fail', props<{ error: string }>());

/***
 * get & save Next visit localy in store
 */
export const getExpectedNextVisit = createAction('[Consultation] Get exptected next visit', props<{ value: PetInfo; nextDate: Date }>());

export const setExpectedNextVisit = createAction('[Consultation] Set exptected next visit', props<{ value: NextVisitData }>());

/***
 * put Next visit to backend
 */
export const updateConsultationNextVisit = createAction(
  '[Consultation] Update next visit',
  props<{ nextVisit: { expected: { visitDateTime: string } }; patientId: string; consultationId: string }>(),
);

export const resetExpectedNextVisit = createAction('[Consultation] Reset next visit');
export const updateConsultationNextVisitSuccess = createAction('[Consultation] Update next visit success');

export const checkForExistingOwner = createAction(
  '[Consultation] Check For Existing Owner',
  props<{ email: string; owner: PetOwner; clinic: Clinic; petInfo: PetInfo; currentConsultation: Consultation }>(),
);
export const placeVetSourceOrder = createAction(
  '[Consultation] Place Vet Source Order',
  props<{ email: string; clinic: Clinic; petInfo: PetInfo; currentConsultation: Consultation }>(),
);
export const placeVetSourceOrderSuccess = createAction('[Consultation] Place Vet Source Order Success');
export const placeVetSourceOrderError = createAction('[Consultation] Place Vet Source Order Error', props<{ error: string }>());
export const setIsWLPEligible = createAction('[Consultation] Set is WLP eligible', props<{ value: boolean }>());
export const setIsWLPIncluded = createAction('[Consultation] Set is WLP included', props<{ value: boolean }>());
